// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"2lS2X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CitNextChevronWrapper", function() {
    return CitNextChevronWrapper;
});
parcelHelpers.export(exports, "CitPrevChevronWrapper", function() {
    return CitPrevChevronWrapper;
});
parcelHelpers.export(exports, "CitNextChevron", function() {
    return CitNextChevron;
});
parcelHelpers.export(exports, "CitPrevChevron", function() {
    return CitPrevChevron;
});
parcelHelpers.export(exports, "BaseSimpleButtonStyle", function() {
    return BaseSimpleButtonStyle;
});
parcelHelpers.export(exports, "SimpleButtonStyle", function() {
    return SimpleButtonStyle;
});
parcelHelpers.export(exports, "SimpleButton", function() {
    return SimpleButton;
});
parcelHelpers.export(exports, "CitArrowAndTextButton", function() {
    return CitArrowAndTextButton;
});
parcelHelpers.export(exports, "PrimaryButtonVersionAStyle", function() {
    return PrimaryButtonVersionAStyle;
});
parcelHelpers.export(exports, "PrimaryButtonVersionBStyle", function() {
    return PrimaryButtonVersionBStyle;
});
parcelHelpers.export(exports, "SecondaryButtonVersionAStyle", function() {
    return SecondaryButtonVersionAStyle;
});
parcelHelpers.export(exports, "SecondaryButtonVersionBStyle", function() {
    return SecondaryButtonVersionBStyle;
});
parcelHelpers.export(exports, "SecondarySimpleButtonStyle", function() {
    return SecondarySimpleButtonStyle;
});
parcelHelpers.export(exports, "PrimaryBorderedSimpleButtonStyle", function() {
    return PrimaryBorderedSimpleButtonStyle;
});
parcelHelpers.export(exports, "SecondaryBorderedSimpleButtonStyle", function() {
    return SecondaryBorderedSimpleButtonStyle;
});
parcelHelpers.export(exports, "PrimaryButton", function() {
    return PrimaryButton;
});
parcelHelpers.export(exports, "PrevButtonElementContainer", function() {
    return PrevButtonElementContainer;
});
parcelHelpers.export(exports, "NextButtonElementContainer", function() {
    return NextButtonElementContainer;
});
parcelHelpers.export(exports, "BackButtonElementContainer", function() {
    return BackButtonElementContainer;
});
parcelHelpers.export(exports, "WideBackButtonElementContainer", function() {
    return WideBackButtonElementContainer;
});
parcelHelpers.export(exports, "AdvisorButtonElementContainer", function() {
    return AdvisorButtonElementContainer;
});
parcelHelpers.export(exports, "ButtonElementContainer", function() {
    return ButtonElementContainer;
});
parcelHelpers.export(exports, "CitChevron", function() {
    return CitChevron;
});
parcelHelpers.export(exports, "CitButton", function() {
    return CitButton;
});
parcelHelpers.export(exports, "CitNextButton", function() {
    return CitNextButton;
});
parcelHelpers.export(exports, "CitPrevButton", function() {
    return CitPrevButton;
});
parcelHelpers.export(exports, "CitBackButton", function() {
    return CitBackButton;
});
parcelHelpers.export(exports, "CitAdvisorButton", function() {
    return CitAdvisorButton;
});
parcelHelpers.export(exports, "CitTextButton", function() {
    return CitTextButton;
});
parcelHelpers.export(exports, "CitSecondaryNextButton", function() {
    return CitSecondaryNextButton;
});
parcelHelpers.export(exports, "CitPrimaryBorderedButton", function() {
    return CitPrimaryBorderedButton;
});
parcelHelpers.export(exports, "CitSecondaryBorderedButton", function() {
    return CitSecondaryBorderedButton;
});
parcelHelpers.export(exports, "CitPrimaryButtonVersionA", function() {
    return CitPrimaryButtonVersionA;
});
parcelHelpers.export(exports, "CitPrimaryButtonVersionB", function() {
    return CitPrimaryButtonVersionB;
});
parcelHelpers.export(exports, "CitSecondaryButtonVersionA", function() {
    return CitSecondaryButtonVersionA;
});
parcelHelpers.export(exports, "CitSecondaryButtonVersionB", function() {
    return CitSecondaryButtonVersionB;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _commonStyles = require("../../../common.styles");
var _logicalProperties = require("../../../styles/general/logical-properties");
var _theme = require("../../../styles/general/theme");
var _commonButton = require("../general/common-button");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  margin-right: ",
        ";\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  margin-left: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  margin-right: ",
        ";\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  margin-left: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  box-sizing: border-box;\n  font-family: ",
        ";\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 17px;\n  padding: 13px 15px;\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n      width: ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n  ",
        ";\n  text-transform: none;\n  background-color: ",
        ";\n  color: ",
        ";\n  border-radius: 24px;\n  text-align: center;\n  hyphens: auto;\n  width: ",
        ";\n\n  ",
        ";\n\n  :hover {\n    background-color: ",
        ";\n    color: ",
        ";\n\n    > * {\n      color: ",
        ";\n    }\n  }\n\n  @media (max-width: ",
        "px) {\n    width: 100%;\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n  ",
        ";\n  font-family: ",
        ";\n  margin: 0 15px;\n  cursor: pointer;\n  display: flex;\n  text-transform: none;\n  text-decoration: none;\n  align-items: center;\n  color: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 24px;\n\n  @media (max-width: ",
        "px) {\n    width: 100%;\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n      color: ",
        "!important;\n      background-color: transparent !important;\n      &:hover {\n        cursor: not-allowed;\n      }\n    "
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n      color: ",
        ";\n\n      :hover {\n        color: ",
        ";\n        text-decoration: underline;\n      }\n    "
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n  ",
        ";\n  font-family: ",
        ";\n  margin: 0 15px;\n  cursor: pointer;\n  display: flex;\n  text-transform: none;\n  text-decoration: none;\n  align-items: center;\n  color: ",
        ";\n  width: fit-content;\n\n  :hover {\n    color: ",
        ";\n  }\n\n  ",
        ";\n\n  @media (max-width: ",
        "px) {\n    width: 100%;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n  border-radius: 24px;\n\n  background-color: ",
        ";\n  color: ",
        ";\n\n  :hover {\n    background-color: ",
        ";\n    color: ",
        ";\n\n    > * {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n  border-radius: 24px;\n\n  background-color: ",
        ";\n  color: ",
        ";\n\n  :hover {\n    background-color: ",
        ";\n    color: ",
        ";\n\n    > * {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n  border-radius: 24px;\n\n  background-color: transparent;\n  color: ",
        ";\n\n  :hover {\n    background-color: ",
        ";\n    color: ",
        ";\n\n    > * {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n  border-radius: 24px;\n\n  background-color: transparent;\n  color: ",
        ";\n\n  :hover {\n    background-color: ",
        ";\n    color: ",
        ";\n\n    > * {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n  background-color: ",
        ";\n  color: ",
        ";\n  border-radius: 24px;\n\n  :hover {\n    background-color: ",
        ";\n    color: ",
        ";\n\n    > * {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n  background-color: transparent;\n  color: ",
        ";\n  border-radius: 24px;\n  border: 1px solid ",
        ";\n\n  :hover {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n  background-color: transparent;\n  color: ",
        ";\n  border-radius: 24px;\n  border: 1px solid ",
        ";\n\n  :hover {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  justify-content: space-between;\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  justify-content: space-between;\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n      color: ",
        "!important;\n      border-color: ",
        ";\n      background-color: transparent !important;\n      &:hover {\n        cursor: not-allowed;\n      }\n    "
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n      color: ",
        ";\n      border-color: ",
        ";\n\n      :hover {\n        background-color: ",
        ";\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n  pointer-events: auto;\n  ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n  ",
        ";\n\n  text-transform: none;\n  font-family: ",
        ";\n  background-color: transparent;\n  color: ",
        ";\n  height: 50px;\n\n  box-sizing: border-box;\n  padding: 13px 17px;\n  line-height: unset;\n\n  > * {\n    padding-bottom: 1px;\n  }\n\n  :hover {\n    background-color: ",
        ";\n    color: ",
        ";\n\n    > * {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  justify-content: space-between;\n"
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  background: transparent;\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  font-family: ",
        ";\n  font-weight: 900;\n  font-size: 14px;\n  line-height: 18px;\n  text-align: center;\n\n  &:visited {\n    color: ",
        ";\n  }\n\n  &:hover {\n    background: ",
        ";\n    border-width: 1px;\n    color: ",
        ";\n\n    & > * {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n      color: ",
        ";\n      border-color: ",
        ";\n      background-color: ",
        ";\n\n      :hover {\n        background-color: ",
        ";\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  font-size: 28px;\n  font-weight: 400;\n  ",
        ";\n  font-family: ",
        ";\n"
    ]);
    _templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  color: ",
        ";\n  ",
        ";\n  ",
        ";\n\n  &:after {\n    content: '\u203A';\n  }\n"
    ]);
    _templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  flex-grow: 1;\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n"
    ]);
    _templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n"
    ]);
    _templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n"
    ]);
    _templateObject33 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n"
    ]);
    _templateObject34 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n"
    ]);
    _templateObject35 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n"
    ]);
    _templateObject36 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n"
    ]);
    _templateObject37 = function _templateObject() {
        return data;
    };
    return data;
}
var CitNextChevronWrapper = (0, _commonStyles.styled).div(_templateObject(), function(p) {
    return p.noMargin ? 0 : 'initial';
}, function(p) {
    return p.noMargin ? 0 : 'initial';
}, function(p) {
    return p.noMargin ? 0 : 'initial';
}, function(p) {
    return p.noMargin ? 0 : '18px';
});
var CitPrevChevronWrapper = (0, _commonStyles.styled).div(_templateObject1(), function(p) {
    return p.noMargin ? 0 : '18px';
}, function(p) {
    return p.noMargin ? 0 : 'initial';
}, function(p) {
    return p.noMargin ? 0 : 'initial';
}, function(p) {
    return p.noMargin ? 0 : 'initial';
});
var CitNextChevron = function(props) {
    var _props_fill;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CitNextChevronWrapper, {
        noMargin: props === null || props === void 0 ? void 0 : props.noMargin,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
            width: "11",
            height: "19",
            viewBox: "0 0 11 19",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M0.180002 1.56L8.16 9.55L0.28 17.45L0.13 17.59L0.28 17.73L1.41 18.86L1.55 19L1.69 18.86L10.86 9.69L11 9.55L10.86 9.41L1.59 0.149999L1.45 -8.34888e-07L1.31 0.149999L0.180002 1.28L0.0300013 1.42L0.180002 1.56Z",
                fill: (_props_fill = props === null || props === void 0 ? void 0 : props.fill) !== null && _props_fill !== void 0 ? _props_fill : 'white'
            })
        })
    });
};
var CitPrevChevron = function(props) {
    var _props_fill;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CitPrevChevronWrapper, {
        noMargin: props === null || props === void 0 ? void 0 : props.noMargin,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
            width: "11",
            height: "19",
            viewBox: "0 0 11 19",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M10.82 17.44L2.84 9.45L10.72 1.55L10.87 1.41L10.72 1.27L9.59 0.14L9.45 0L9.31 0.14L0.14 9.31L0 9.45L0.14 9.59L9.41 18.85L9.55 19L9.69 18.85L10.82 17.72L10.97 17.58L10.82 17.44Z",
                fill: (_props_fill = props === null || props === void 0 ? void 0 : props.fill) !== null && _props_fill !== void 0 ? _props_fill : '#DA291C'
            })
        })
    });
};
var BaseSimpleButtonStyle = (0, _commonStyles.css)(_templateObject2(), (0, _theme.primaryFont), (0, _commonButton.SecondaryButtonWithDisabledStyle));
var SimpleButtonStyle = (0, _commonStyles.css)(_templateObject4(), (0, _commonButton.BasicButtonStyle), BaseSimpleButtonStyle, function(p) {
    return p.disabled ? (0, _theme.baseColor)(730) : (0, _theme.primaryColor)(p.variant === 'primary' ? 200 : p.variant === 'secondary' ? 900 : 100);
}, function(p) {
    return p.disabled ? (0, _theme.baseColor)(500) : p.variant === 'secondary' ? (0, _theme.primaryColor)(100) : (0, _theme.baseColor)(900);
}, function(p) {
    return p.fullWidth ? '100%' : 'fit-content';
}, function(p) {
    return p.width && (0, _commonStyles.css)(_templateObject3(), p.width);
}, (0, _theme.baseColor)(250), (0, _theme.baseColor)(900), (0, _theme.baseColor)(900), (0, _theme.mobile));
var SimpleButton = (0, _commonStyles.styled).a(_templateObject5(), SimpleButtonStyle);
var CitArrowAndTextButtonWrapper = (0, _commonStyles.styled).a(_templateObject6(), (0, _commonButton.BasicButtonStyle), BaseSimpleButtonStyle, (0, _theme.primaryFont), (0, _theme.primaryColor)(200), (0, _theme.primaryColor)(200), (0, _theme.mobile));
var CitTextButtonWrapper = (0, _commonStyles.styled).a(_templateObject9(), (0, _commonButton.BasicButtonStyle), BaseSimpleButtonStyle, (0, _theme.primaryFont), (0, _theme.primaryColor)(200), function(p) {
    return p.darkBackground ? (0, _theme.baseColor)(900) : (0, _theme.baseColor)(100);
}, function(p) {
    return p.disabled && (0, _commonStyles.css)(_templateObject7(), (0, _theme.baseColor)(730));
}, (0, _theme.mobile), function(p) {
    return p.darkMode && (0, _commonStyles.css)(_templateObject8(), (0, _theme.baseColor)(900), (0, _theme.baseColor)(900));
});
var CitArrowAndTextButton = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(CitArrowAndTextButtonWrapper, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(CitBackChevron, {}),
            props.children
        ]
    }));
};
var PrimaryButtonVersionAStyle = (0, _commonStyles.css)(_templateObject10(), SimpleButtonStyle, function(p) {
    return p.disabled ? (0, _theme.secondaryColor)(850) : (0, _theme.primaryColor)(200);
}, function(p) {
    return p.disabled ? (0, _theme.baseColor)(725) : (0, _theme.baseColor)(900);
}, (0, _theme.primaryColor)(300), (0, _theme.baseColor)(900), (0, _theme.baseColor)(900));
var PrimaryButtonVersionBStyle = (0, _commonStyles.css)(_templateObject11(), SimpleButtonStyle, function(p) {
    return p.disabled ? (0, _theme.secondaryColor)(850) : (0, _theme.primaryColor)(100);
}, function(p) {
    return p.disabled ? (0, _theme.baseColor)(725) : (0, _theme.baseColor)(900);
}, (0, _theme.primaryColor)(300), (0, _theme.baseColor)(900), (0, _theme.baseColor)(900));
var SecondaryButtonVersionAStyle = (0, _commonStyles.css)(_templateObject12(), SimpleButtonStyle, function(p) {
    return p.disabled ? (0, _theme.baseColor)(500) : (0, _theme.primaryColor)(200);
}, (0, _theme.primaryColor)(200), (0, _theme.baseColor)(900), (0, _theme.baseColor)(900));
var SecondaryButtonVersionBStyle = (0, _commonStyles.css)(_templateObject13(), SimpleButtonStyle, function(p) {
    return p.disabled ? (0, _theme.baseColor)(500) : (0, _theme.primaryColor)(100);
}, (0, _theme.primaryColor)(100), (0, _theme.baseColor)(900), (0, _theme.baseColor)(900));
var SecondarySimpleButtonStyle = (0, _commonStyles.css)(_templateObject14(), SimpleButtonStyle, function(p) {
    return p.disabled ? (0, _theme.baseColor)(730) : (0, _theme.primaryColor)(100);
}, function(p) {
    return p.disabled ? (0, _theme.baseColor)(500) : (0, _theme.baseColor)(900);
}, (0, _theme.baseColor)(250), (0, _theme.baseColor)(900), (0, _theme.baseColor)(900));
var PrimaryBorderedSimpleButtonStyle = (0, _commonStyles.css)(_templateObject15(), SimpleButtonStyle, (0, _theme.primaryColor)(100), (0, _theme.primaryColor)(100), (0, _theme.primaryColor)(100), (0, _theme.baseColor)(900));
var SecondaryBorderedSimpleButtonStyle = (0, _commonStyles.css)(_templateObject16(), SimpleButtonStyle, (0, _theme.primaryColor)(200), (0, _theme.primaryColor)(200), (0, _theme.primaryColor)(200), (0, _theme.baseColor)(900));
var PrimaryButton = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SimpleButton, (0, _objectSpreadProps._)((0, _objectSpread._)({
        variant: props.variant,
        onClick: props.onClick,
        href: props.href,
        className: props.className
    }, props), {
        children: props.children
    }));
};
var PrevButtonElementContainer = (0, _commonStyles.styled)(SimpleButton)(_templateObject17());
var NextButtonElementContainer = (0, _commonStyles.styled)(SimpleButton)(_templateObject18());
var SecondaryButton = (0, _commonStyles.styled)(SimpleButton)(_templateObject21(), SecondaryBorderedSimpleButtonStyle, function(p) {
    return p.disabled && (0, _commonStyles.css)(_templateObject19(), (0, _theme.baseColor)(730), (0, _theme.baseColor)(730));
}, function(p) {
    return p.darkMode && (0, _commonStyles.css)(_templateObject20(), (0, _theme.baseColor)(900), (0, _theme.baseColor)(900), (0, _theme.baseColor)(900), (0, _theme.primaryColor)(200));
});
var BackButtonElementContainer = (0, _commonStyles.styled).a(_templateObject22(), (0, _commonButton.BasicButtonStyle), BaseSimpleButtonStyle, (0, _theme.primaryFont), function(p) {
    return p.disabled ? (0, _theme.baseColor)(500) : (0, _theme.primaryColor)(100);
}, (0, _theme.primaryColor)(100), (0, _theme.baseColor)(900), (0, _theme.baseColor)(900));
var WideBackButtonElementContainer = (0, _commonStyles.styled)(BackButtonElementContainer)(_templateObject23());
var AdvisorButtonElementContainer = (0, _commonStyles.styled)(SimpleButton)(_templateObject24(), (0, _theme.primaryColor)(100), (0, _theme.primaryColor)(100), (0, _theme.primaryFont), (0, _theme.primaryColor)(100), (0, _theme.primaryColor)(100), (0, _theme.baseColor)(875), (0, _theme.baseColor)(875));
var ButtonElementContainer = (0, _commonStyles.styled)(SimpleButton)(_templateObject26(), (0, _logicalProperties.paddingInline)(15, 10), function(p) {
    return p.darkMode && (0, _commonStyles.css)(_templateObject25(), (0, _theme.primaryColor)(200), (0, _theme.baseColor)(900), (0, _theme.baseColor)(900), (0, _theme.primaryColor)(200), (0, _theme.baseColor)(900));
});
var ChevronStyle = (0, _commonStyles.css)(_templateObject27(), (0, _logicalProperties.marginInline)(8, 0), (0, _theme.primaryFont));
var CitChevron = (0, _commonStyles.styled).div(_templateObject28(), function(p) {
    return p.theme.color.base[900];
}, (0, _logicalProperties.paddingInline)(5, 0), ChevronStyle);
var CitBackChevron = (0, _commonStyles.styled)(CitPrevChevron)(_templateObject29(), function(p) {
    return p.theme.color.primary[100];
}, (0, _logicalProperties.paddingInline)(0, 5));
var ButtonTextNoPadding = (0, _commonStyles.styled).span(_templateObject30());
var CitButton = function(props) {
    var _props_variant;
    var variant = (_props_variant = props.variant) === null || _props_variant === void 0 ? void 0 : _props_variant.toLowerCase();
    switch(variant){
        case 'icon':
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(NextButtonElementContainer, (0, _objectSpreadProps._)((0, _objectSpread._)({
                onClick: props.onClick,
                href: props.href,
                className: props.className
            }, props), {
                variant: 'primary',
                children: [
                    props.children,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(CitNextChevron, {})
                ]
            }));
        case 'tertiary':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CitTextButtonWrapper, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
                onClick: props.onClick,
                href: props.href,
                target: props.target,
                className: props.className,
                children: props.children
            }));
        case 'secondary':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SecondaryButton, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
                variant: variant,
                onClick: props.onClick,
                href: props.href,
                target: props.target,
                className: props.className,
                children: props.children
            }));
        case 'primary':
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ButtonElementContainer, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
                variant: variant,
                onClick: props.onClick,
                href: props.href,
                target: props.target,
                className: props.className,
                children: props.children
            }));
    }
};
var CitNextButton = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(NextButtonElementContainer, (0, _objectSpreadProps._)((0, _objectSpread._)({
        variant: props.variant,
        onClick: props.onClick,
        href: props.href,
        className: props.className
    }, props), {
        children: [
            props.children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(CitNextChevron, {})
        ]
    }));
};
var CitPrevButton = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PrevButtonElementContainer, (0, _objectSpreadProps._)((0, _objectSpread._)({
        variant: props.variant,
        onClick: props.onClick,
        href: props.href,
        className: props.className
    }, props), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(CitPrevChevron, {}),
            props.children
        ]
    }));
};
var CitBackButton = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(BackButtonElementContainer, (0, _objectSpreadProps._)((0, _objectSpread._)({
        onClick: props.onClick,
        href: props.href,
        className: props.className
    }, props), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(CitBackChevron, {}),
            props.children
        ]
    }));
};
var CitAdvisorButton = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(AdvisorButtonElementContainer, (0, _objectSpreadProps._)((0, _objectSpread._)({
        variant: props.variant,
        onClick: props.onClick,
        href: props.href,
        className: props.className
    }, props), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ButtonTextNoPadding, {
            children: props.children
        })
    }));
};
var CitTextButton = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CitArrowAndTextButtonWrapper, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: props.children
    }));
};
var CitSecondaryNextButton = (0, _commonStyles.styled)(CitButton)(_templateObject31(), SecondarySimpleButtonStyle);
var CitPrimaryBorderedButton = (0, _commonStyles.styled)(CitButton)(_templateObject32(), PrimaryBorderedSimpleButtonStyle);
var CitSecondaryBorderedButton = (0, _commonStyles.styled)(CitButton)(_templateObject33(), SecondaryBorderedSimpleButtonStyle);
var CitPrimaryButtonVersionA = (0, _commonStyles.styled)(CitButton)(_templateObject34(), PrimaryButtonVersionAStyle);
var CitPrimaryButtonVersionB = (0, _commonStyles.styled)(CitButton)(_templateObject35(), PrimaryButtonVersionBStyle);
var CitSecondaryButtonVersionA = (0, _commonStyles.styled)(CitButton)(_templateObject36(), SecondaryButtonVersionAStyle);
var CitSecondaryButtonVersionB = (0, _commonStyles.styled)(CitButton)(_templateObject37(), SecondaryButtonVersionBStyle);

},{"@swc/helpers/_/_object_spread":"7ZOov","@swc/helpers/_/_object_spread_props":"8MPJG","@swc/helpers/_/_tagged_template_literal":"8vvZL","react/jsx-runtime":"lhkWg","react":"gjea9","../../../common.styles":"9NP4o","../../../styles/general/logical-properties":"aE74e","../../../styles/general/theme":"h7q57","../general/common-button":"6u2Pj","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=citroen-loader.837ddae5.js.map
